import { EnvironmentConfig } from '@otto-ec/eprivacy-shared'
import { getOnetrustDataDomainScriptConfig } from './get-onetrust-data-domain-script-config'
import { ONETRUST_SDK_INTEGRITY_HASHES } from './onetrust-sdk-integrity-hashes'
import { ConsentProviderConfig } from '../../ports'

export function onetrustConfig(
  config: EnvironmentConfig
): EnvironmentConfig & ConsentProviderConfig {
  const onetrustSiteConfig = getOnetrustDataDomainScriptConfig(config.stage)

  return {
    ...config,
    onetrust: {
      onetrustSiteConfig,
      integrityHashes: ONETRUST_SDK_INTEGRITY_HASHES,
    },
  }
}
